import { render, staticRenderFns } from "./ShortVideoCommentList.vue?vue&type=template&id=5c6f4c4b&scoped=true"
import script from "./ShortVideoCommentList.vue?vue&type=script&lang=js"
export * from "./ShortVideoCommentList.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoCommentList.vue?vue&type=style&index=0&id=5c6f4c4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6f4c4b",
  null
  
)

export default component.exports